// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Atom_Text_Ds from "./Atom_Text_Ds.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";

function make(layout) {
  if (layout === "Outside") {
    return {
            blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.Inside.makeTop("XS")),
            text: {
              TAG: /* Outside */0,
              _0: {
                copyright: Atom_Text_Ds.ImageCaption.makeCopyright(/* Outside */1),
                title: Atom_Text_Ds.ImageCaption.title
              }
            }
          };
  } else {
    return {
            blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "M", undefined)), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XXS", undefined)),
            text: {
              TAG: /* Inside */1,
              _0: Atom_Text_Ds.ImageCaption.makeCopyright(/* Inside */0)
            }
          };
  }
}

function view(param) {
  var text = param.text;
  var tmp;
  tmp = text.TAG === /* Outside */0 ? /* Outside */1 : /* Inside */0;
  var tmp$1;
  if (text.TAG === /* Outside */0) {
    var match = text._0;
    tmp$1 = {
      copyright: Atom_Text_Ds.ImageCaption.toParent(match.copyright),
      title: Atom_Text_Ds.ImageCaption.toParent(match.title)
    };
  } else {
    tmp$1 = {
      copyright: Atom_Text_Ds.ImageCaption.toParent(text._0),
      title: undefined
    };
  }
  return {
          position: tmp,
          blockSpace: param.blockSpace,
          text: tmp$1
        };
}

export {
  make ,
  view ,
}
/* Atom_Text_Ds Not a pure module */
